/* Sóller — interactions (Shopify port). Idempotent: re-inits on editor section loads.
   Horizon scrolls inside .page-wrapper, not the window — so all scroll listeners
   are attached to BOTH the window and the .page-wrapper scroll container. */
(function () {
  'use strict';

  if (window.__sollerInit) return;
  window.__sollerInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Listen for scrolling wherever it happens (Horizon's .page-wrapper or the window). */
  function onScroll(fn) {
    window.addEventListener('scroll', fn, { passive: true });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', fn, { passive: true });
  }

  /* RequestAnimationFrame-throttled scroll handler. */
  function onFrame(fn) {
    var ticking = false;
    onScroll(function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { fn(); ticking = false; });
      }
    });
    fn();
  }

  function init(root) {
    root = root || document;

    /* ---- Scroll reveals ---- */
    var revealEls = root.querySelectorAll('.reveal:not(.is-in)');
    revealEls.forEach(function (el) {
      var d = el.getAttribute('data-delay');
      if (d !== null) el.style.setProperty('--d', d);
    });
    if (reduced || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }

    /* ---- Hero banner slow drift ---- */
    root.querySelectorAll('.hero__media img').forEach(function (heroImg) {
      if (heroImg.__sollerDrift || reduced) return;
      heroImg.__sollerDrift = true;
      onFrame(function () {
        var r = heroImg.getBoundingClientRect();
        var vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        heroImg.style.transform = 'translateY(' + (p * 5).toFixed(2) + '%) scale(1.12)';
      });
    });

    /* ---- Manifesto word-fill on scroll ---- */
    root.querySelectorAll('[data-fill]').forEach(function (manifesto) {
      if (manifesto.__sollerFill) return;
      manifesto.__sollerFill = true;
      var words = manifesto.textContent.trim().split(/\s+/);
      manifesto.innerHTML = words.map(function (w) {
        return '<span class="w">' + w + '</span>';
      }).join(' ');
      var spans = manifesto.querySelectorAll('.w');
      if (reduced) {
        spans.forEach(function (s) { s.classList.add('lit'); });
      } else {
        onFrame(function () {
          var rect = manifesto.getBoundingClientRect();
          var vh = window.innerHeight;
          var total = rect.height + vh * 0.55;
          var passed = (vh * 0.85 - rect.top);
          var p = Math.min(1, Math.max(0, passed / total));
          var lit = Math.floor(p * spans.length);
          spans.forEach(function (s, i) { s.classList.toggle('lit', i < lit); });
        });
      }
    });

    /* ---- FAQ accordion (one open at a time) ---- */
    root.querySelectorAll('.faq__item').forEach(function (item) {
      if (item.__sollerFaq) return;
      item.__sollerFaq = true;
      var q = item.querySelector('.faq__q');
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.faq__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---- Smooth scroll to sections (with email focus where requested) ---- */
    root.querySelectorAll('[data-scrollto]').forEach(function (a) {
      if (a.__sollerScroll) return;
      a.__sollerScroll = true;
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var target = document.getElementById(a.getAttribute('data-scrollto'));
        if (!target) return;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (a.hasAttribute('data-focus')) {
          setTimeout(function () {
            var input = target.querySelector('input[type="email"]');
            if (input) input.focus({ preventScroll: true });
          }, reduced ? 100 : 700);
        }
      });
    });

    /* ---- Email signup: AJAX to Shopify /contact, graceful native fallback ---- */
    root.querySelectorAll('form.signup').forEach(function (form) {
      if (form.__sollerForm) return;
      form.__sollerForm = true;
      form.addEventListener('submit', function (ev) {
        var input = form.querySelector('input[type="email"]');
        var val = (input.value || '').trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val);
        if (!ok) {
          ev.preventDefault();
          input.focus();
          input.style.borderColor = '#C0392B';
          setTimeout(function () { input.style.borderColor = ''; }, 1200);
          return;
        }
        ev.preventDefault();
        fetch('/contact', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (r.ok) {
              form.classList.add('signup--done');
              form.innerHTML =
                '<svg viewBox="0 0 52 52" aria-hidden="true"><circle cx="26" cy="26" r="24" fill="none" stroke="#0A93A3" stroke-width="2.5"/><path fill="none" stroke="#0A93A3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M15 27l7 7 15-16"/></svg>' +
                '<p><strong>You\u2019re on the list.</strong> Welcome to the golden hour.</p>';
            } else {
              form.submit();
            }
          })
          .catch(function () { form.submit(); });
      });
    });

    /* ---- Footer year ---- */
    root.querySelectorAll('[data-year]').forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
